import React from 'react';

const Scoreboard = () => {
  return (
    <div style={{ background: '#FFFFFF60', display: 'grid', alignContent: 'center', justifyContent: 'center', height: '100px' }}>SCOREBOARD</div>
  );
};

export default Scoreboard;
